import createReducer from '../createReducer';
import {NotificationsState} from './notifications.type';

const initialState: NotificationsState = {
    list: null,
    all: null,
    pending: [],
    getUserNotificationsXHR: null,
    updateUserNotificationXHR: null,
};

const reducer = createReducer('notifications', initialState);

export default reducer;
